import { render, staticRenderFns } from "./unitFour.vue?vue&type=template&id=23b75237&scoped=true"
import script from "./unitFour.vue?vue&type=script&lang=js"
export * from "./unitFour.vue?vue&type=script&lang=js"
import style0 from "./unitFour.vue?vue&type=style&index=0&id=23b75237&prod&lang=less&scoped=true"
import style1 from "./unitFour.vue?vue&type=style&index=1&id=23b75237&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b75237",
  null
  
)

export default component.exports